import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  variant?: 'default' | 'elevated' | 'outlined' | 'glass';
  padding?: 'none' | 'sm' | 'md' | 'lg' | 'xl';
}

export const Card: React.FC<CardProps> = ({
  children,
  className = '',
  onClick,
  variant = 'default',
  padding = 'none',
}) => {
  const variants = {
    default: 'bg-surface-primary border border-border-primary shadow-soft',
    elevated: 'bg-surface-primary shadow-medium',
    outlined: 'bg-surface-primary border-2 border-border-primary',
    glass: 'bg-white/80 backdrop-blur-sm border border-white/20 shadow-soft',
  };

  const paddings = {
    none: '',
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
    xl: 'p-10',
  };

  return (
    <div
      className={`
        rounded-xl transition-all duration-300 
        ${variants[variant]}
        ${paddings[padding]}
        ${onClick ? 'cursor-pointer hover:shadow-medium hover:-translate-y-1' : ''}
        ${className}
      `}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export const CardHeader: React.FC<CardProps> = ({
  children,
  className = '',
}) => {
  return (
    <div className={`p-6 border-b border-border-primary ${className}`}>
      {children}
    </div>
  );
};

export const CardBody: React.FC<CardProps> = ({ children, className = '' }) => {
  return <div className={`p-6 ${className}`}>{children}</div>;
};

export const CardFooter: React.FC<CardProps> = ({
  children,
  className = '',
}) => {
  return (
    <div
      className={`p-6 border shadow-lg border-border-primary bg-background-secondary rounded-xl ${className}`}
    >
      {children}
    </div>
  );
};
